export default __webpack_public_path__ + "static/media/id-back.5a70f0be.png";